module.exports = __webpack_public_path__ + "static/media/nav-arrow-right.36a9d641.svg";